import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

const ResponsiveMenu = () => {
  const { userLoggedIn } = useSelector(state => state)
  return (
    <div className='flex flex-col absolute right-0 top-11 rounded-b-md w-screen items-right bg-gray-900 max-[350px]:top-9 z-50 min-[751px]:hidden text-center font-mono pb-4'>

      <Link className='mx-1 p-1 text-lg font-serif cursor-pointer hover:bg-slate-700 rounded-lg' to='/' >HOME</Link>
      <a className='mx-1 p-1 text-lg font-serif cursor-pointer hover:bg-slate-700 rounded-lg' href='/all-news-feed?gender=F&category=apparel' >WOMEN APPAREL NEWSFEED</a>
      <a className='mx-1 p-1 text-lg font-serif cursor-pointer hover:bg-slate-700 rounded-lg' href='/all-news-feed?gender=M&category=apparel' >MEN APPAREL NEWSFEED</a>
      <div className='flex w-full justify-center'>
        <hr className='border-b border-dashed my-4 w-3/4' />
      </div>
      <a className='mx-1 p-1 text-lg font-serif cursor-pointer hover:bg-slate-700 rounded-lg' href='/all-news-feed?gender=F&category=non-apparel' >WOMEN BAG FOOTWEAR ACCESSORY FEED</a>
      <a className='mx-1 p-1 text-lg font-serif cursor-pointer hover:bg-slate-700 rounded-lg' href='/all-news-feed?gender=M&category=non-apparel' >MEN BAG FOOTWEAR ACCESSORY FEED</a>
      <div className='flex w-full justify-center'>
        <hr className='border-b border-dashed my-4 w-3/4' />
      </div>
      <a className='mx-1 p-1 text-lg font-serif cursor-pointer hover:bg-slate-700 rounded-lg' href='/all-news-feed?gender=F&category=Ethinic+Wear&sort=rog&geography=All&alltrends=' >ETHNICWEAR NEWSFEED</a>
      <a className='mx-1 p-1 text-lg font-serif cursor-pointer hover:bg-slate-700 rounded-lg' href='/all-news-feed?gender=F&category=apparel&sort=rog&geography=indian&alltrends=' >INDIA TIER I & II NEWSFEED</a>
      <div className='flex w-full justify-center'>
        <hr className='border-b border-dashed my-4 w-3/4' />
      </div>
      <Link className='mx-1 p-1 text-lg font-serif cursor-pointer hover:bg-slate-700 rounded-lg' to='/must-have-designs' >MUST HAVE DESIGNS</Link>
      <Link className='mx-1 p-1 text-lg font-serif cursor-pointer hover:bg-slate-700 rounded-lg' to='/saved-images' >MY COLLECTIONS</Link>
    </div >
  )
}

export default ResponsiveMenu
